const TERMS_OF_SERVICE_URL_APPLEPAY = 'https://developer.apple.com/terms/apple-pay-web'
const TERMS_OF_SERVICE_URL_GOOGLEPAY = 'https://payments.developers.google.com/terms/sellertos'
const TERMS_OF_SERVICE_URL_PAYPAL = 'https://www.paypal.com/it/legalhub/useragreement-full'

// PPRO: ALIPAY, BANCONTACT, EPS IDEAL, MULTIBANCO, P24, SATISPAY, WECHAT

export const APM = {
  APPLEPAY: {
    name: 'Apple Pay',
    serviceProvider: 'APPLE',
    termsOfServiceUrl: TERMS_OF_SERVICE_URL_APPLEPAY,
    description: {
      id: 't.app.settings.apmConfiguration.popUp.description.apple',
      defaultMessage: 'Apple Pay allows quick and secure payments with Apple devices.'
    }
  },
  GOOGLEPAY: {
    name: 'Google Pay',
    serviceProvider: 'GOOGLE',
    termsOfServiceUrl: TERMS_OF_SERVICE_URL_GOOGLEPAY,
    description: {
      id: 't.app.settings.apmConfiguration.popUp.description.google',
      defaultMessage: 'Google Pay is the digital wallet developed by Google.'
    }
  },
  PAYPAL: {
    name: 'PayPal',
    serviceProvider: 'PAYPAL',
    termsOfServiceUrl: TERMS_OF_SERVICE_URL_PAYPAL,
    description: {
      id: 't.app.settings.apmConfiguration.popUp.description.paypal',
      defaultMessage: 'PayPal is one of the leading digital payment services worldwide.'
    }
  },
  PAYPALPAGAIN3: {
    name: 'PayPal Pay in 3',
    serviceProvider: 'PAYPALPAYIN3',
    description: {
      id: 't.app.settings.apmConfiguration.popUp.description.paypalIn3',
      defaultMessage: 'Buy now and pay later with PayPal Pay in 3.'
    }
  },
  PPROALIPAY: {
    name: 'Alipay',
    serviceProvider: 'PPRO',
    description: {
      id: 't.app.settings.apmConfiguration.popUp.description.alipay',
      defaultMessage: 'Alipay is the most popular mobile online payment service in China.'
    }
  },
  ALIPAY_PLUS: {
    name: 'Alipay+',
    serviceProvider: 'ALIPAY_PLUS',
    description: {
      id: 't.app.settings.apmConfiguration.popUp.description.alipayPlus',
      defaultMessage: 'AliPay is the most widely used online payment system in China, allowing for easy and fast payments.'
    }
  },
  BANCOMATPAY: {
    name: 'Bancomat Pay',
    serviceProvider: 'BANCOMATPAY',
    description: {
      id: 't.app.settings.apmConfiguration.popUp.description.bancomatPay',
      defaultMessage: 'Digital service offered by BANCOMAT which allows  online payments with mobile phone number.'
    }
  },
  PPROBANCONTACT: {
    name: 'Bancontact',
    serviceProvider: 'PPRO',
    description: {
      id: 't.app.settings.apmConfiguration.popUp.description.bancontact',
      defaultMessage: 'Bancontact is one of the leading digital payment in Belgium.'
    }
  },
  PPROEPS: {
    name: 'EPS',
    serviceProvider: 'PPRO',
    description: {
      id: 't.app.settings.apmConfiguration.popUp.description.eps',
      defaultMessage:
        'EPS (Electronic Payment standard) is a secure direct bank transfer payment method popular in Austria and Germany.'
    }
  },
  PPROIDEAL: {
    name: 'iDEAL',
    serviceProvider: 'PPRO',
    description: {
      id: 't.app.settings.apmConfiguration.popUp.description.iDeal',
      defaultMessage: 'iDeal is a secure direct bank transfer payment method popular in the Netherlands.'
    }
  },
  PPROMULTIBANCO: {
    name: 'Multibanco',
    serviceProvider: 'PPRO',
    description: {
      id: 't.app.settings.apmConfiguration.popUp.description.multibanco',
      defaultMessage: 'Multibanco is a Portuguese interbank payment method.'
    }
  },
  MYBANK: { 
    name: 'MyBank',
    serviceProvider: 'MYBANK', 
    description: {
      id: 't.app.settings.apmConfiguration.popUp.description.myBankISP',
      defaultMessage: 'Pay by immediate bank transfer securely and easily from bank account.'
    }
  },
  PPROP24: {
    name: 'P24',
    serviceProvider: 'PPRO',
    description: {
      id: 't.app.settings.apmConfiguration.popUp.description.p24',
      defaultMessage: 'P24 is a popular wire transfer payment service in Poland and the Czech Republic.'
    }
  },
  PPROSATISPAY: {
    name: 'Satispay',
    serviceProvider: 'PPRO',
    description: {
      id: 't.app.settings.apmConfiguration.popUp.description.satispay',
      defaultMessage: 'Satispay is a mobile payment method that allows you to shop online and at participating stores.'
    }
  },
  SATISPAY: {
    name: 'Satispay',
    serviceProvider: 'SATISPAY_DIRECT',
    description: {
      id: 't.app.settings.apmConfiguration.popUp.description.satispay',
      defaultMessage: 'Satispay is a mobile payment method that allows you to shop online and at participating stores.'
    }
  },
  PPROWECHAT: {
    name: 'WeChat',
    serviceProvider: 'PPRO',
    description: {
      id: 't.app.settings.apmConfiguration.popUp.description.weChat',
      defaultMessage: 'WeChat Pay is the digital wallet of the WeChat app.'
    }
  },
  HEYLIGHT: {
    name: 'HeyLight',
    serviceProvider: 'HEYLIGHT',
    description: {
      id: 't.app.settings.apmConfiguration.popUp.description.heyLight',
      defaultMessage: 'HeyLight allows flexible deferred payments with or without interests.'
    }
  },
  KLARNA: {
    name: 'Klarna',
    serviceProvider: 'KLARNA',
    description: {
      id: 't.app.settings.apmConfiguration.popUp.description.klarna',
      defaultMessage: 'Quick, secure and flexible payments. Pay now or buy now and pay later.'
    }
  },
  IRIS: {
    name: 'Iris',
    serviceProvider: 'IRIS',
    description: {
      id: 't.app.settings.apmConfiguration.popUp.description.iris',
      defaultMessage: 'IRIS allows instant payments through mobile phones in Greece.'
    }
  },
  ACCOUNTTOPAY: {
    name: 'AccountToPay',
    serviceProvider: 'ACCOUNTTOPAY',
    description: {
      id: 't.app.settings.apmConfiguration.popUp.description.accountToPay',
      defaultMessage: 'AccountToPay allows customers to make secure digital payments via SEPA credit transfer.'
    }
  }
}
